// plugins/counselorStatus.js
export default defineNuxtPlugin(() => {
  if (!import.meta.client) return;

  // 폴링/SSE 중 어느 방식으로 붙을지는 composable 이 VUE_STATUS_MODE 를 보고 결정한다.
  const { start, stop } = useCounselorStatus();

  start(); // 앱 시작 시 자동 시작

  window.addEventListener("beforeunload", () => stop());
});
